import Modal from "react-modal";
import React, { useEffect, useState } from "react";
import Styles from "./complete.module.scss";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { Inputs, props } from "./types";
import { Services } from "Service/service";
import { warningSwal } from "Reusable/utils/Toast";
import { AiOutlineClose } from "react-icons/ai";
import swal from "sweetalert";
import Details from "../ClassDetails/details";
Modal.setAppElement("#root");

const DemoForm: React.FC<props> = ({ modal, setModal, getDetails, id }) => {
    const {
        handleSubmit,
        reset,
        register,
        setValue,
        control,
        watch,
        formState: { errors },
    } = useForm<Inputs>({ defaultValues: { is_partial_completed: false } });
    const token = {
        Authorization: `token ${localStorage.getItem("MathNinjaToken")}`,
    };
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        reset({
            Comments: getDetails?.data?.Comments,
            NewTopicDone: getDetails?.data?.NewTopicDone,
        });
    }, []);
    const watchData = watch();
    // CLOSE FORM
    const closeModal = () => {
        setModal(false);
        reset();
    };

    // FORM SUBMIT
    const onSubmit: SubmitHandler<Inputs> = async (formdata) => {
        setLoading(true);
        let Body: any = {
            ...formdata,
        };
        try {
            const CompleteClass = await Services.Update_CompletedClass(
                "PUT",
                JSON.stringify(Body),
                token,
                id
            );
            setLoading(false);
            if (CompleteClass.Status === 1) {
                swal("Updated", CompleteClass.Message, "success");
                setModal(false);
                getDetails?.details(id);
            } else {
                warningSwal("Warning", CompleteClass?.Message);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
            warningSwal("Error", "Something went wrong please try again");
        }
    };

    return (
        <Modal
            isOpen={modal}
            contentLabel="Modal"
            className={Styles["modal"]}
            onRequestClose={closeModal}
            overlayClassName={Styles["overlay"]}>
            <div className={Styles["form-wrapper"]}>
                <button onClick={closeModal}>
                    <AiOutlineClose />
                </button>
                <h2>update Class</h2>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="">
                            Topic taken today <span>:</span>
                        </label>
                        <div className={Styles["form-control-one"]}>
                            <input
                                type="text"
                                {...register("NewTopicDone", {
                                    required: false,
                                })}
                            />
                            {errors.NewTopicDone && (
                                <span style={{ color: "red" }}>
                                    This is required
                                </span>
                            )}
                        </div>
                    </div>
                    <div className={Styles["form-control"]}>
                        <label htmlFor="Comments">
                            Description of Topic <span>:</span>
                        </label>

                        <textarea
                            {...register("Comments", {
                                required: false,
                            })}></textarea>
                    </div>

                    {/* eslint-disable-next-line */}

                    <div className={Styles["buttons"]}>
                        <button
                            type="submit"
                            className={Styles["submit"]}
                            disabled={loading}>
                            {loading ? "...please wait" : "Complete"}
                        </button>
                        <button
                            type="button"
                            onClick={closeModal}
                            className={Styles["close"]}>
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
};
export default DemoForm;
